/* eslint-disable max-len */
import * as React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
// import { analytics } from 'common/utils';
import * as api from 'api';
import _ from 'lodash';

import { ROOT_ROUTE } from 'client/constants';
import { Responsive } from 'common/components';
import { Header, RabbiCredit, Button } from 'client/components/common';
import { fileLink } from 'utils/file-link';
import MobilePopup from './MobilePopup';
import * as css from './ChoicePage.scss';

export default class ChoicePage extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		match: PropTypes.shape({
			params: PropTypes.shape({
				choiceId: PropTypes.string,
			}),
		}).isRequired,
		isStarted: PropTypes.bool.isRequired,
		user: PropTypes.shape({}),
		in: PropTypes.bool.isRequired,
		songsCategory: PropTypes.shape({}),
		artistsCategory: PropTypes.shape({}),
		albumsCategory: PropTypes.shape({}),
		bestSongCategory: PropTypes.shape({}),
		worstSongCategory: PropTypes.shape({}),
	};

	static defaultProps = {
		className: '',
		songsCategory: {},
		artistsCategory: {},
		albumsCategory: {},
		bestSongCategory: {},
		worstSongCategory: {},
		user: null,
	};

	state = {
		animationState: '',
		selectedItems: [],
		isShowPopup: false,
	};

	async componentDidMount() {
		const { match } = this.props;
		const result = await api.getParticipant({ participantId: match.params.choiceId });

		if (result.success && result.data) {
			this.setState({ selectedItems: result.data });
		}
	}

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	showPopup = () => {
		this.setState({
			isShowPopup: true,
		});
	};

	hidePopup = () => {
		this.setState({
			isShowPopup: false,
		});
	};

	render() {
		const {
			className,
			isStarted,
			songsCategory,
			artistsCategory,
			albumsCategory,
			bestSongCategory,
			worstSongCategory,
		} = this.props;
		const { animationState, selectedItems, isShowPopup } = this.state;
		const cssTProps = _.omit(this.props, [
			'className',
			'isStarted',
			'staticContext',
			'songsCategory',
			'artistsCategory',
			'albumsCategory',
			'bestSongCategory',
			'worstSongCategory',
		]);
		// const isDesktop = Responsive.isMatching(Responsive.DESKTOP);
		// const isMobile = Responsive.isMatching(Responsive.MOBILE);

		const songsTitle = 'השירים שלי לשנת 2025';
		const artistTitle = 'אנשי השנה';
		const albumsTitle = 'אלבום השנה';
		const bestSongTitle = 'הופעת השנה';
		const worstSongTitle = 'השיר הגרוע';

		// const prText = 'צילום: יח"צ חו"ל, Alexandra waespi';
		const buttonLabel = 'עוד לא הצבעתם? כנסו עכשיו >>';

		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div className={classNames(css.choicePage, isStarted && css[animationState], className)}>
					<Header
						className={css.header}
						isCategory
						isHideInHeader={this.state.isHideInHeader}
						isScrolling={this.state.isScrolling}
					/>
					<div
						className={css.genearlBg}
						style={{ backgroundImage: 'url(/assets/client/imgs/general-bg.png)' }}
					></div>

					<div className={css.content}>
						<div className={css.result}>
							{songsCategory && (
								<div className={css.songs}>
									<h4 className={css.title}>{songsTitle}</h4>
									<div className={css.songsList}>
										{_.map(selectedItems[_.get(songsCategory, 'id')], song => {
											return (
												<p key={song.id} className={css.songsListItem}>
													<span>{song.title}</span> - {song.subtitle}
												</p>
											);
										})}
									</div>
								</div>
							)}
							<div className={css.artistsAndAlbums}>
								{artistsCategory && (
									<div className={css.artists}>
										<h4 className={css.title}>{artistTitle}</h4>
										<div className={css.artistsList}>
											{_.map(selectedItems[_.get(artistsCategory, 'id')], song => {
												return (
													<div
														key={song.id}
														className={css.artistsListItem}
														style={{ backgroundImage: `url(${fileLink(song.file)})` }}
													>
														<p className={css.description}>{song.title}</p>
													</div>
												);
											})}
										</div>
									</div>
								)}
								<div className={css.oneItemCategoriesGroup}>
									{albumsCategory && (
										<div className={css.albums}>
											<h4 className={css.title}>{albumsTitle}</h4>
											<div className={css.albumsList}>
												{_.map(selectedItems[_.get(albumsCategory, 'id')], album => {
													return (
														<div
															key={album.id}
															className={css.albumsListItem}
															style={{ backgroundImage: `url(${fileLink(album.file)})` }}
														>
															<p className={css.description}>
																<div>{album.subtitle}</div>
																<span>{album.title}</span>
															</p>
														</div>
													);
												})}
											</div>
										</div>
									)}
									{bestSongCategory && (
										<div className={css.albums}>
											<h4 className={css.title}>{bestSongTitle}</h4>
											<div className={css.albumsList}>
												{_.map(selectedItems[_.get(bestSongCategory, 'id')], album => {
													return (
														<div
															key={album.id}
															className={css.albumsListItem}
															style={{ backgroundImage: `url(${fileLink(album.file)})` }}
														>
															<p className={css.description}>
																<div>{album.title}</div>
																<span>{album.subtitle}</span>
															</p>
														</div>
													);
												})}
											</div>
										</div>
									)}
									{worstSongCategory && (
										<div className={css.albums}>
											<h4 className={css.title}>{worstSongTitle}</h4>
											<div className={css.albumsList}>
												{_.map(selectedItems[_.get(worstSongCategory, 'id')], album => {
													return (
														<div
															key={album.id}
															className={css.albumsListItem}
															style={{ backgroundImage: `url(${fileLink(album.file)})` }}
														>
															<p className={css.description}>
																<div>{album.title}</div>
																<span>{album.subtitle}</span>
															</p>
														</div>
													);
												})}
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						{/* <p className={css.prText} style={{ direction: 'rtl' }}>
							{prText}
						</p> */}
						{/* <Responsive query={[Responsive.DESKTOP, Responsive.TABLET]}> */}
						<Link to={ROOT_ROUTE}>
							<Button type="button" label={buttonLabel} className={css.button} />
						</Link>
						{/* </Responsive> */}
						{/* <Responsive query={Responsive.MOBILE}>
							<div className={css.instaTrigger}>
								<Link to={ROOT_ROUTE}>
									<Button type="button" label={buttonLabel} className={css.button} />
								</Link>
							</div>
						</Responsive> */}
					</div>

					{isShowPopup && (
						<MobilePopup
							selection={selectedItems[_.get(songsCategory, 'id')]}
							isShowPopup={isShowPopup}
							hidePopup={this.hidePopup}
							// user={user}
						/>
					)}

					{/* <MakoAnalytics pageId={MAKO_ANALYTICS_PAGE_IDS.MAIN()} /> */}
					{!isShowPopup && (
						<RabbiCredit
							className={css.rabbiCredit}
							theme={Responsive.isMatching(Responsive.DESKTOP) ? 'light' : 'dark'}
						/>
					)}
				</div>
			</CSSTransition>
		);
	}
}
